<div class="data">
  <table>
    <thead>
      @if (showGroups) {
        <tr name="groups" class="groups">
          @for (group of groups; track group.label) {
            <th [class]="groupClasses(group)" [attr.colspan]="group.columns.length">
              {{ group.label }}
            </th>
          }
        </tr>
      }
      <tr name="columns" class="columns">
        @for (column of columns; track $index) {
          <th [class]="headerClasses(column)">
            <span name="label" class="label">{{ column.label }}</span>
            @if (column.filter) {
              <app-table-column-filter
                identifier="{{ column.key }}"
                [filters]="column.filter | async"
                [selected]="getSelectedFilters(column.key)"
                (filter)="applyFilter($event)"
              />
            }
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (
        row of data
          | paginate
            : {
                id: dataId,
                itemsPerPage: itemsPerPage,
                currentPage: page,
                totalItems: totalItems,
              }
          | tableFormatter: columns;
        track rowIndex;
        let rowIndex = $index
      ) {
        <tr [class]="rowConfig ? rowConfig.getCssClasses(data[rowIndex]) : ''">
          @for (col of columns; track i; let i = $index) {
            <td [class]="cellClasses(col)">
              @if (row[i] && col.displayType === displayType.Audio) {
                <audio [src]="row[i]" preload="none" controls></audio>
              }
              @if (col.displayType === displayType.PlainText) {
                <div>
                  {{ row[i] }}
                </div>
              }
              @if (col.dropdownOptions) {
                <div ngbDropdown [placement]="dropdownPlacement(rowIndex)">
                  <button name="toggle" class="btn btn-primary" ngbDropdownToggle>
                    {{ row[i] }}
                  </button>
                  <div ngbDropdownMenu>
                    @for (opt of col.dropdownOptions; track opt) {
                      <button
                        class="dropdown-item"
                        (click)="changeCellData(col, rowIndex, row[i], opt)"
                      >
                        {{ opt }}
                      </button>
                    }
                  </div>
                </div>
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
<pagination-template
  #p="paginationApi"
  class="paginator-container"
  [id]="dataId"
  (pageChange)="paginate($event)"
>
  @if (p.pages.length > 1) {
    <nav aria-label="Paginated Table Results" class="paginator" name="paginator">
      <ul class="pagination">
        <li class="page-item" [class.disabled]="p.isFirstPage()">
          <button
            class="page-link"
            name="previous"
            angulartics2On="click"
            angularticsCategory="Chart"
            angularticsAction="Paginate Previous"
            [angularticsLabel]="codename"
            (click)="p.previous()"
          >
            <i class="icon fas fa-angle-left" title="previous"></i>
          </button>
        </li>
        @for (page of p.pages; track page.value) {
          <li class="page-item" [class.active]="p.getCurrent() === page.value">
            <button
              class="page-link"
              name="page"
              angulartics2On="click"
              angularticsCategory="Chart"
              [angularticsAction]="'Paginate ' + page.value"
              [angularticsLabel]="codename"
              (click)="p.setCurrent(page.value)"
            >
              {{ page.label }} <span class="visually-hidden">(current)</span>
            </button>
          </li>
        }
        <li class="page-item" [class.disabled]="p.isLastPage()">
          <button
            class="page-link"
            name="next"
            angulartics2On="click"
            angularticsCategory="Chart"
            angularticsAction="Paginate Next"
            [angularticsLabel]="codename"
            (click)="p.next()"
          >
            <i class="icon fas fa-angle-right" title="next"></i>
          </button>
        </li>
      </ul>
    </nav>
  }
</pagination-template>
